import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SalesRevenueOverview from "../../components/dashboard/SalesRevenueOverview";
import ProductPerformanceOverview from "../../components/dashboard/ProductPerformanceOverview";
import ClaimsOverview from "../../components/dashboard/ClaimsOverview";
import { currentDashboardYear } from "../../components/dashboard/YearSelect";
import dashboardService from "../../api/DashboardService";

export default function Dashboard() {
  const [year, setYear] = useState(currentDashboardYear);
  const [sales, setSales] = useState(null);
  const [products, setProducts] = useState(null);
  const [claims, setClaims] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      const [salesResult, productResult, claimsResult] = await Promise.all([
        dashboardService.getSalesRevenue(year),
        dashboardService.getProductPerformance(year),
        dashboardService.getClaims(year),
      ]);
      if (cancelled) return;

      setSales(salesResult.status ? salesResult.data : null);
      setProducts(productResult.status ? productResult.data : null);
      setClaims(claimsResult.status ? claimsResult.data : null);
      setLoading(false);

      const failed = [salesResult, productResult, claimsResult].find((result) => !result.status);
      if (failed) toast.error(failed.message);
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [year]);

  return (
    <div className="min-h-full bg-gray-50">
      <div className="p-6">
        <SalesRevenueOverview
          year={year}
          setYear={setYear}
          data={sales}
          loading={loading}
        />
        <ProductPerformanceOverview
          year={year}
          setYear={setYear}
          data={products}
          loading={loading}
        />
        <ClaimsOverview
          year={year}
          setYear={setYear}
          data={claims}
          loading={loading}
        />
      </div>
    </div>
  );
}
